export default {"src":"/_next/static/media/educate-staff.7c8c476d.svg","height":720,"width":1280,"blurWidth":0,"blurHeight":0};